export default {
  methods: {
    /**
     * Handles a promise, showing appropriate snackbar messages for loading, success, and error states.
     * @param {Promise} promise - The promise to handle.
     * @param {Object} [messages] - Optional custom messages.
     * @param {string} [messages.loadingMessage] - Message to show while processing.
     * @param {string} [messages.successMessage] - Message to show on success.
     * @param {string} [messages.errorMessagePrefix] - Prefix for error message.
     * @returns {Promise} - The original promise, allowing further chaining or error handling.
     */
    async handleRequest(
      promise,
      {
        loadingMessage = "Processing...",
        successMessage = "Operation successful!",
        errorMessagePrefix = "Error: ",
      } = {}
    ) {

      try {
        const result = await promise;
        this.$store.dispatch("snackbar/showSnackbar", {
          message: successMessage,
          color: "success",
        });
        return result;
      } catch (error) {
        let message = "An unexpected error occurred.";
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          message = error.response.data.message;
        } else if (error && error.message) {
          message = error.message;
        }
        this.$store.dispatch("snackbar/showSnackbar", {
          message: `${errorMessagePrefix}${message}`,
          color: "error",
          timeout: 8000, // Longer timeout for errors
        });
        throw error; // Re-throw the error so the calling component can also handle it if needed
      }
    },

    // Simpler methods for direct snackbar calls if needed
    showSuccessSnackbar(message, timeout) {
      this.$store.dispatch("snackbar/showSnackbar", {
        message: message || "Operation successful!",
        color: "success",
        timeout: timeout || 4000,
      });
    },
    showErrorSnackbar(message, timeout) {
      this.$store.dispatch("snackbar/showSnackbar", {
        message: message || "Došlo je do greške.",
        color: "error",
        timeout: timeout || 8000,
      });
    },
    showInfoSnackbar(message, timeout) {
      this.$store.dispatch("snackbar/showSnackbar", {
        message: message || "Obrada u toku...",
        color: "info",
        timeout: timeout || 4000,
      });
    },
    showWarningSnackbar(message, timeout) {
      this.$store.dispatch("snackbar/showSnackbar", {
        message: message || "Upozorenje.",
        color: "warning",
        timeout: timeout || 7000,
      });
    },
  },
};
